/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketing.asset.permissions.rpc.UserPermissionsRpc
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const getUserIdsRpc = {
  serviceName: 'com.hubspot.marketing.asset.permissions.rpc.UserPermissionsRpc',
  rpcName: 'getUserIds',
  auth: 'app',
  fingerprint: 'Y4hwNVV7gJFaMw4KanG77IyLzSMwKT7c',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateUserIdsRpc = {
  serviceName: 'com.hubspot.marketing.asset.permissions.rpc.UserPermissionsRpc',
  rpcName: 'updateUserIds',
  auth: 'app',
  fingerprint: 'n-PM_8WRrx6OUe2e_r4XmYyLzSMwKT7c',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};